<template>
  <section class="grid-flex column">
    <div class="flex w100">
      <div class="box">
        <div class="box-title flex middle">
          <div>
            <h3>Conversões Personalizadas</h3>
          </div>
          <div class="flex-1 flex end">
            <div class="button primary" @click="showModalCreate = true">
              Adicionar Nova Conversão
            </div>
          </div>
        </div>
        <div class="box-content">
          <ul>
            <li v-for="(w, index) in conversions" :key="index">
              <div class="flex row">
                <div class="flex-2">
                  <div>{{ w.name }}</div>
                  <div class="margin-top-s">
                    Palavra Chave: {{ w.rule_name }}
                  </div>
                  <div class="margin-top-s">
                    Plataforma: {{ w.platform }}
                  </div>
                </div>
                <div class="flex-1 flex end margin-top-s">
                  <div class="button secondary" @click="newDevice=w; showModalCreate = true">Editar</div>
                  <div class="button secondary" @click="selectedWhats=w; showModalDelete = true">Deletar</div>
                </div>
              </div>
            </li>
          </ul>
          <div v-if="loading">
            <content-loading>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
            </content-loading>
          </div>
          <div v-if="isEmpty">
            Você não tem conversões de whatsapp cadastrados. Adicione o sua primeira conversão.
          </div>
        </div>
      </div>
    </div>

    <!-- modal confirm delete -->
    <modal-confirm
        :show="showModalDelete"
        description="Você tem certeza que deseja deletar esta conversão whatsapp?"
        @cancel="
          showModalDelete = false;
          selectedWhats = null;
        "
        @accept="deleteConversionWhats(selectedWhats)"
      ></modal-confirm>

      <modal
        :title="titleModal"
        :show="showModalCreate"
        @close="cleanModal()"
      >
        <div class="content flex column " slot="content">
          <form autocomplete="off" class="w100">
              <div class="flex-1 w100">
                <label>Nome da conversão</label>
                <input
                  class="input"
                  id="name"
                  type="text"
                  v-model="newDevice.name"
                  autocomplete="off"
                />
              </div>
              <div class="flex-1 w100 margin-top-s flex column">
                <label>Palavra Chave</label>
                <small>* Vamos útilizar esta palavra para definir que a conversa teve tal conversão.</small>
                <input
                  class="input"
                  id="name"
                  type="text"
                  v-model="newDevice.rule_name"
                  autocomplete="off"
                />
              </div>
              <div class="flex-1 w100 margin-top-s">
                <label>Tipo de Evento:</label>
                <select class="input" v-model="newDevice.event_name">
                  <option value="">Seleciona</option>
                  <option v-for="(f, index) in listEvent" :key="index" :value="f" :selected="f === newDevice.event_name">
                    {{ f }}
                  </option>
                </select>
              </div>
              
              <div class="flex-1 w100 margin-top-s">
                <label>Valor do Evento:</label>
                <money v-model="newDevice.event_value" v-bind="money"></money>
              </div>
              <div class="flex-1 w100 margin-top-s">
                <label>Plataforma:</label>
                <select class="input" v-model="newDevice.platform">
                  <option value="">Seleciona</option>
                  <option v-for="(f, index) in listPlatform" :key="index" :value="f" :selected="f === newDevice.platform">
                    {{ f }}
                  </option>
                </select>
              </div>
              <div v-if="newDevice.platform === 'GOOGLEADS'">
                <div class="flex-1 w100 margin-top-s flex column">
                  <label>Conversion Id</label>
                  <input
                    class="input"
                    id="name"
                    type="text"
                    v-model="newDevice.conversion_id"
                    autocomplete="off"
                  />
                </div>
                <div class="flex-1 w100 margin-top-s flex column">
                  <label>Rótulo da Conversão</label>
                  <input
                    class="input"
                    id="name"
                    type="text"
                    v-model="newDevice.conversion_name"
                    autocomplete="off"
                  />
                </div>
              </div>
            </form>
          <div class="flex column w100">
            <div class="flex w100 center margin-top-l">
              <div class="button primary" @click="createOrupdateConversionWhats()">SALVAR</div>
            </div>
          </div>
        </div>
      </modal>
  </section>
</template>

<script>
import { mapState } from "vuex";
import { Money } from 'v-money'

import {
  createConversionWhats,
  getConversionWhats,
  deleteConversionWhats,
  updateConversionWhats,
} from "@/services/conversionWhats";

import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";


export default {
  name: "conversion-whats",
  components: {
    Modal,
    ModalConfirm,
    Money
  },
  data() {
    return {
      showModalDelete: false,
      selectedWhats: null,
      showModalQR: false,
      showModalCreate: false,
      loading: false,
      newDevice: {
        name: '',
        rule_name: '',
        event_name: '',
        event_value: '',
        conversion_id: '',
        conversion_name: '',
        platform: '',
      },
      conversions: [],
      listPlatform: [
        'FACEBOOKADS',
        // 'GOOGLEADS',
        // 'TIKTOKADS',
      ],
      listEvent: [
        'VENDA',
        'ORÇAMENTO',
        'AGENDAMENTO',
        // 'CADASTRO',
      ],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    };
  },
  watch: {
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    titleModal() {
      if (this.newDevice.id) {
        return 'Editar Conversão'
      }

      return 'Criar nova Conversão'
    },
    isEmpty() {
      return !this.loading && this.conversions && this.conversions.length === 0
    }
  },
  mounted() {
    this.getConversionWhats();
  },
  methods: {
    cleanModal() {
      this.newDevice = {
        name: '',
        rule_name: '',
        event_name: '',
        event_value: '',
        platform: '',
        conversion_id: '',
        conversion_name: '',
      }
      this.showModalCreate = false
    },
    createOrupdateConversionWhats() {
      if (this.newDevice.id) {
        this.updateConversionWhats()
      } else {
        this.createConversionWhats()
      }
    },
    createConversionWhats() {
      let data = {
        name: this.newDevice.name,
        rule_name: this.newDevice.rule_name,
        event_name: this.newDevice.event_name,
        event_value: this.newDevice.event_value,
        platform: this.newDevice.platform,
        conversion_id: this.newDevice.conversion_id,
        conversion_name: this.newDevice.conversion_name,
      };

      if (!data.name) {
        this.$toast.error({
          title: "Erro",
          message: "Você precisa preencher os campos para salvar o whatsapp",
        });
      }
      createConversionWhats(data)
        .then((result) => {
          this.$toast.success({
            title: "Sucesso",
            message: "Whatsapp salva com sucesso",
          });

          this.conversions.push(result)
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao tentar salvar whatsapp",
          });
        })
        .finally(() => {
          this.showModalCreate = false
        })
    },
    getConversionWhats() {
      this.loading = true
      getConversionWhats()
        .then((result) => {
          this.conversions = result.conversion_whats
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao buscar conversões personalizadas",
          });
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateConversionWhats() {
      let params = {
        name: this.newDevice.name,
        rule_name: this.newDevice.rule_name,
        event_name: this.newDevice.event_name,
        event_value: this.newDevice.event_value,
        platform: this.newDevice.platform,
        conversion_id: this.newDevice.conversion_id,
        conversion_name: this.newDevice.conversion_name,
      }
      updateConversionWhats(this.newDevice.id, params)
        .then(() => {
          this.$toast.success({
            title:'Sucesso',
            message:'Editado com sucesso'
          })
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
        .finally(() => {
          this.showModalCreate = false
          this.selectedWhats = null
        })
    },
    deleteConversionWhats(whats) {
      deleteConversionWhats(whats.id)
        .then(() => {
          this.$toast.success({
            title:'Sucesso',
            message:'Removido com sucesso'
          })
          this.conversions = this.conversions.filter(e => e.id != whats.id)
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
        .finally(() => {
          this.showModalDelete = false
          this.selectedWhats = null
        })
    },
  },
};
</script>

<style lang="scss" scoped>
li {
  list-style-type: none;
  border-bottom: 1px solid #dfdfdf;
  margin-bottom: 16px;
  padding: 16px 4px;
  .button {
    margin-right: 8px;
  }
}

</style>
